import Footer from '../components/Footer';
import Navbar from '../components/Navbar';

export default function TermsOfService() {
  return (
    <div className="min-h-screen bg-[#FFFBF7] text-[#5F5650]">
      <Navbar />
      <main className="px-4 py-12 md:px-8">
        <article className="mx-auto w-full max-w-[800px] rounded-2xl bg-white p-6 shadow-sm md:p-10">
          <h1 className="font-[Nunito] text-4xl font-extrabold text-[#5B3FA6]">PottyPal Terms of Service</h1>
          <p className="mt-2 text-sm text-[#7B716A]">Last updated: April 2026</p>
          <p className="text-sm text-[#7B716A]">
            Support:{' '}
            <a className="text-[#5B3FA6] underline" href="mailto:support@logicalflows.com">
              support@logicalflows.com
            </a>
          </p>

          <section className="mt-8 space-y-6 leading-relaxed">
            <div>
              <h2 className="font-[Nunito] text-2xl font-bold text-[#4A3F66]">1. ACCEPTANCE OF TERMS</h2>
              <p className="mt-2">
                By downloading, installing, or using PottyPal (&quot;the App&quot;), you agree to be bound by these Terms of
                Service (&quot;Terms&quot;). If you do not agree, do not use the App.
              </p>
              <p className="mt-2">
                These Terms constitute a legally binding agreement between you and LogicalFlows (&quot;we,&quot; &quot;us,&quot;
                or &quot;our&quot;).
              </p>
            </div>

            <div>
              <h2 className="font-[Nunito] text-2xl font-bold text-[#4A3F66]">2. DESCRIPTION OF SERVICE</h2>
              <p className="mt-2">PottyPal is an AI-powered potty training companion app that provides:</p>
              <ul className="mt-2 list-disc space-y-1 pl-6">
                <li>Personalized potty training guidance and AI coaching tips</li>
                <li>Smart reminder system based on your child&apos;s patterns</li>
                <li>Progress tracking and analytics</li>
                <li>Child-friendly interactive features (stickers, pet companions)</li>
                <li>Co-parent synchronization features</li>
              </ul>
            </div>

            <div>
              <h2 className="font-[Nunito] text-2xl font-bold text-[#4A3F66]">3. ELIGIBILITY</h2>
              <p className="mt-2">
                You must be at least 18 years old and a parent or legal guardian to create a PottyPal account. By using
                the App, you represent and warrant that you meet this requirement.
              </p>
            </div>

            <div>
              <h2 className="font-[Nunito] text-2xl font-bold text-[#4A3F66]">4. ACCOUNT REGISTRATION</h2>
              <p className="mt-2">You are responsible for:</p>
              <ul className="mt-2 list-disc space-y-1 pl-6">
                <li>Maintaining the confidentiality of your account credentials</li>
                <li>All activities that occur under your account</li>
                <li>Providing accurate and complete information</li>
                <li>Notifying us immediately of any unauthorized account use</li>
              </ul>
            </div>

            <div>
              <h2 className="font-[Nunito] text-2xl font-bold text-[#4A3F66]">5. SUBSCRIPTION PLANS AND BILLING</h2>
              <h3 className="mt-3 font-[Nunito] text-xl font-bold text-[#4A3F66]">5.1 Free Plan:</h3>
              <p className="mt-2">
                Available at no charge with limited features including basic logging, daily tips, and potty timer reminders.
              </p>

              <h3 className="mt-4 font-[Nunito] text-xl font-bold text-[#4A3F66]">5.2 Premium Plan ($4.99/month or $29.99/year):</h3>
              <p className="mt-2">
                Includes unlimited logging, AI Coach chat, full analytics, co-parent sync, custom training plans, and more.
              </p>

              <h3 className="mt-4 font-[Nunito] text-xl font-bold text-[#4A3F66]">5.3 Pro Family Plan ($8.99/month or $49.99/year):</h3>
              <p className="mt-2">
                Includes everything in Premium plus up to 5 child profiles, 3 caregiver accounts, milestone videos, AI
                stories, and regression support.
              </p>

              <h3 className="mt-4 font-[Nunito] text-xl font-bold text-[#4A3F66]">5.4 Free Trial:</h3>
              <p className="mt-2">
                New Premium and Pro subscribers receive a 7-day free trial. No charge during the trial period. Cancel before
                trial ends to avoid charges.
              </p>

              <h3 className="mt-4 font-[Nunito] text-xl font-bold text-[#4A3F66]">5.5 Billing:</h3>
              <ul className="mt-2 list-disc space-y-1 pl-6">
                <li>Subscriptions are billed through Google Play</li>
                <li>Payments are processed by Google - we do not store card details</li>
                <li>
                  Subscriptions auto-renew unless cancelled at least 24 hours before the renewal date
                </li>
                <li>Manage or cancel subscriptions in Google Play account settings</li>
              </ul>

              <h3 className="mt-4 font-[Nunito] text-xl font-bold text-[#4A3F66]">5.6 Refunds:</h3>
              <p className="mt-2">
                Refund requests are subject to Google Play&apos;s refund policy. Contact{' '}
                <a className="text-[#5B3FA6] underline" href="mailto:support@logicalflows.com">
                  support@logicalflows.com
                </a>{' '}
                within 48 hours of purchase for assistance.
              </p>
            </div>

            <div>
              <h2 className="font-[Nunito] text-2xl font-bold text-[#4A3F66]">6. NOT MEDICAL ADVICE</h2>
              <p className="mt-2">
                IMPORTANT: PottyPal provides general potty training guidance and information only. The App is NOT a substitute
                for professional medical or psychological advice.
              </p>
              <ul className="mt-2 list-disc space-y-1 pl-6">
                <li>AI-generated tips are informational only</li>
                <li>We make no guarantee of specific potty training outcomes</li>
                <li>Always consult your pediatrician for health concerns about your child</li>
                <li>
                  If your child has developmental, medical, or psychological needs, seek appropriate professional guidance
                </li>
              </ul>
            </div>

            <div>
              <h2 className="font-[Nunito] text-2xl font-bold text-[#4A3F66]">7. ACCEPTABLE USE</h2>
              <p className="mt-2">You agree NOT to:</p>
              <ul className="mt-2 list-disc space-y-1 pl-6">
                <li>Use the App for any unlawful purpose</li>
                <li>Share your account with non-family members without authorization</li>
                <li>Attempt to reverse engineer, hack, or tamper with the App</li>
                <li>Use the App to harass, abuse, or harm others</li>
                <li>Upload false, misleading, or inappropriate content</li>
                <li>Circumvent any subscription or payment mechanism</li>
              </ul>
            </div>

            <div>
              <h2 className="font-[Nunito] text-2xl font-bold text-[#4A3F66]">8. INTELLECTUAL PROPERTY</h2>
              <p className="mt-2">
                All content in PottyPal - including text, graphics, logos, AI responses, and software - is owned by
                LogicalFlows and protected by copyright law.
              </p>
              <p className="mt-2">
                You may not reproduce, distribute, or create derivative works from our content without written permission.
              </p>
            </div>

            <div>
              <h2 className="font-[Nunito] text-2xl font-bold text-[#4A3F66]">9. AI-GENERATED CONTENT</h2>
              <p className="mt-2">
                PottyPal uses Google Gemini AI to generate personalized coaching content. You acknowledge that:
              </p>
              <ul className="mt-2 list-disc space-y-1 pl-6">
                <li>AI responses are generated automatically and may not always be accurate</li>
                <li>AI content does not constitute professional advice</li>
                <li>We are not liable for decisions made based on AI-generated tips</li>
              </ul>
            </div>

            <div>
              <h2 className="font-[Nunito] text-2xl font-bold text-[#4A3F66]">10. PRIVACY</h2>
              <p className="mt-2">
                Your use of the App is also governed by our Privacy Policy, available at pottypal.app/privacy (and within the
                App). The Privacy Policy is incorporated into these Terms by reference.
              </p>
            </div>

            <div>
              <h2 className="font-[Nunito] text-2xl font-bold text-[#4A3F66]">11. LIMITATION OF LIABILITY</h2>
              <p className="mt-2">TO THE MAXIMUM EXTENT PERMITTED BY LAW:</p>
              <ul className="mt-2 list-disc space-y-1 pl-6">
                <li>PottyPal is provided &quot;as is&quot; without warranties of any kind</li>
                <li>We do not guarantee the App will be error-free or uninterrupted</li>
                <li>We are not liable for any indirect, incidental, or consequential damages</li>
                <li>
                  Our total liability to you shall not exceed the amount you paid us in the 12 months preceding the claim
                </li>
              </ul>
            </div>

            <div>
              <h2 className="font-[Nunito] text-2xl font-bold text-[#4A3F66]">12. TERMINATION</h2>
              <p className="mt-2">We may suspend or terminate your account if you:</p>
              <ul className="mt-2 list-disc space-y-1 pl-6">
                <li>Violate these Terms</li>
                <li>Use the App in a way that harms other users or LogicalFlows</li>
                <li>Fail to pay subscription fees</li>
              </ul>
              <p className="mt-2">You may delete your account at any time from Settings → Data &amp; Privacy.</p>
            </div>

            <div>
              <h2 className="font-[Nunito] text-2xl font-bold text-[#4A3F66]">13. CHANGES TO TERMS</h2>
              <p className="mt-2">
                We may modify these Terms at any time. Material changes will be communicated via in-app notification or email.
                Continued use after changes constitutes acceptance of the new Terms.
              </p>
            </div>

            <div>
              <h2 className="font-[Nunito] text-2xl font-bold text-[#4A3F66]">14. GOVERNING LAW</h2>
              <p className="mt-2">
                These Terms are governed by applicable law. Any disputes shall be resolved through good faith negotiation,
                followed by binding arbitration if necessary.
              </p>
            </div>

            <div>
              <h2 className="font-[Nunito] text-2xl font-bold text-[#4A3F66]">15. CONTACT</h2>
              <p className="mt-2">Questions about these Terms:</p>
              <p className="mt-2">
                Email:{' '}
                <a className="text-[#5B3FA6] underline" href="mailto:support@logicalflows.com">
                  support@logicalflows.com
                </a>
              </p>
              <p>Response time: within 2 business days</p>
              <p className="mt-2">LogicalFlows</p>
              <p>
                <a className="text-[#5B3FA6] underline" href="mailto:support@logicalflows.com">
                  support@logicalflows.com
                </a>
              </p>
            </div>

            <p className="border-t border-[#EFE6DD] pt-6 font-semibold">
              By using PottyPal, you acknowledge that you have read, understood, and agree to be bound by these Terms of
              Service.
            </p>
          </section>
        </article>
      </main>
      <Footer />
    </div>
  );
}

